import {BILLING_DISABLED_DELETE_BTN} from './action-types';
import { IDeleteProps } from '../methods/disabled-delete-button';

export interface IDisabledBtn {
    type: string
    data: IDeleteProps
}

export const disabledDeleteBtn = (data: IDeleteProps): IDisabledBtn => ({
    type: BILLING_DISABLED_DELETE_BTN,
    data
})
